<template>
    <span ref="resourceLinkElement">
        <targeting-router-link
            v-if="panelContent"
            class="text-primary hover:text-accent underline"
            :data-cy
            :to="panelContent"
            :menu-items="menuItems"
        >
            <slot/>
            <UChip v-if="getFeatureValue('comments') && hasUnresolvedThreadForUrn" standalone/>
        </targeting-router-link>
        <span v-else>{{ `${urn.type}:${urn.display}` }}</span>
    </span>
</template>

<script setup lang="ts">
import { TargetingRouterLink } from '@tritt/multipanel'
import {computed, ref} from 'vue'
import {resolvePanelContent, ResourceLink} from '@/resource-link/resourceLink'
import {useTransactionCreator} from '@/transaction/create-transaction/TransactionCreator.service'
import {IContextMenuItem} from '@tritt/multipanel'
import {useComment} from '@/comment/comment.service'
import {getFeatureValue} from '@/feature-toggles/feature-toggler.service'

const props = defineProps({
    urn: {
        type: Object as () => ResourceLink,
        required: true
    },
    menuItems: {
        type: Array as () => IContextMenuItem[],
        required: false,
        default: () => []
    },
    dataCy: {
        type: String,
        required: false
    }
})

const panelContent = computed(() => resolvePanelContent(props.urn))

const resourceLinkElement = ref<HTMLSpanElement | null>(null)

const {resourceLinks} = useTransactionCreator()
const {activeResourceLinkElement, commentPopupVisible, commentThreadUrn, unresolvedCommentThreads} = useComment()

const hasUnresolvedThreadForUrn = computed(() => {
    return unresolvedCommentThreads.value?.some(thread => thread.resourceLink.identifier === props.urn.identifier) ?? false
})

const menuItems = computed<IContextMenuItem[]>(() => {
    const items: IContextMenuItem[] = []

    if (getFeatureValue('comments')) {
        items.push(
            {
                label: 'Kommentarer',
                onSelect() {
                    commentPopupVisible.value = false
                    setTimeout(() => {
                        commentPopupVisible.value = true
                        activeResourceLinkElement.value = resourceLinkElement.value
                        commentThreadUrn.value = props.urn
                    }, 50)
                }
            }
        )
    }

    items.push({
        label: 'Legg til bilag',
        onSelect: () => {
            if (!resourceLinks.value.includes(props.urn)) resourceLinks.value.push(props.urn)
        }
    })

    if (resourceLinks.value.includes(props.urn)) {
        items.push({
            label: 'Fjern fra bilag',
            onSelect: () => {
                const index = resourceLinks.value.indexOf(props.urn)
                if (index !== -1) {
                    resourceLinks.value.splice(index, 1)
                }
            }
        })
    }

    items.push(...props.menuItems)

    return items
})

</script>

<style scoped>

</style>